/* ==========================================================================
   Archive Index Section — vanilla JS
   Handles optional fade-in-on-scroll animation via IntersectionObserver.
   ========================================================================== */

(function () {
  'use strict';

  function initSection(section) {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    var enableAnimation = section.dataset.enableAnimation === 'true';
    if (!enableAnimation) return;

    section.classList.add('archive-index--animate');

    if (!('IntersectionObserver' in window)) {
      section.classList.add('archive-index--in-view');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('archive-index--in-view');
            observer.unobserve(section);
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(section);
  }

  function initAll() {
    document.querySelectorAll('[data-archive-index]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-archive-index]');
    if (section) {
      section.dataset.initialized = 'false';
      initSection(section);
    }
  });
})();